
















import Vue from 'vue';
import Component from 'vue-class-component';
import { FooterCompanyDetails } from '@/types/contentServerContract';
import serverContext from '@/core/serverContext.service';

@Component
export default class CheckoutContactInfo extends Vue {
    get phoneNumber(): string | undefined {
        return this.companyDetails?.phoneNumber;
    }

    get phoneNumberLink(): string | undefined {
        return `tel:${this.phoneNumber}`;
    }

    get email(): string | undefined {
        return this.companyDetails?.email;
    }

    get emailLink(): string | undefined {
        return `mailto:${this.email}`;
    }

    get openingHours(): string | undefined {
        return this.companyDetails?.openingHours;
    }

    get companyDetails(): FooterCompanyDetails | null {
        return serverContext?.footer?.companyDetails;
    }
}
